import React, {useContext, useEffect, useState} from 'react';
import {Badge, Button, Card, Col, Spinner, Tab, Table, Tabs} from "react-bootstrap";
import Row from "react-bootstrap/Row";
import UsdUserLogsInDashboard from "./UsdUserLogsInDashboard";

const UsdBalanceLogsInDashboard = () => {
    const [key, setKey] = React.useState('usdlogs');
    const [refreshKeys, setRefreshKeys] = React.useState({
        usdlogs: 0,
        transfer: 0,
    });

    const handleSelect = (nextKey) => {
        setKey(nextKey);
        setRefreshKeys((prev) => ({
            ...prev,
            [nextKey]: (prev[nextKey] || 0) + 1,
        }));
    };

    return (
        <Card className="p-2 w-100 mt-2">
            <Row className="p-2">

                <Col>
                    <Tabs activeKey={key} onSelect={handleSelect} className="mb-3 nav-success" >
                        <Tab eventKey="usdlogs" title="Usd Balance Logs" className="">

                            <UsdUserLogsInDashboard refreshKey={refreshKeys.usdlogs} />
                        </Tab>

                        <Tab eventKey="transfer" title="How to spend">
                            <Card className="p-3 w-100 mt-0">   <h5 className="text-muted mb-0">Usd Balance Usage</h5>
                                <div className="d-flex justify-content-start align-items-center">

                                    <div className="text-muted small mt-2">
                                        <p className="mb-2">
                                            This balance is used to pay for services inside the platform. Wherever a feature can be paid from this balance,
                                            you’ll see it clearly marked on the site.
                                        </p>

                                        <p className="mb-2">
                                            What this balance covers in particular:
                                        </p>
                                        <ul className="mb-2">
                                            <li>Compensation for paperback/hardcover purchases (Verified Purchase assignments for Paper books).</li>
                                            <li>Polls (Pools) — audience surveys, A/B tests, and similar research tasks.</li>
                                            <li>
                                                To purchase Virts on the Exchange, go to <b>Virt Balance → Buy Virt</b> (or <b>Sell Virt</b> if you wish).
                                            </li>
                                            <li>Certain additional options and utilities available within the platform.</li>
                                        </ul>


                                        <p className="mb-2">
                                            Charges are applied automatically when you place an order (e.g., create a poll) or when a qualifying event occurs
                                            (e.g., confirmed paperback compensation). The list of supported features will continue to grow.
                                        </p>

                                        <p className="mb-0">
                                            <b>Note:</b> this is a payments-only balance. Payouts/withdrawals or transfers from this balance are not supported.
                                        </p>
                                    </div>


                                </div>
                            </Card>

                        </Tab>

                    </Tabs>
                </Col>
            </Row>
        </Card>
    );
};

export default UsdBalanceLogsInDashboard;
